import React, {  } from 'react';

interface HandshakeProps {
    fill: string;
}
const Handshake = (props: HandshakeProps) => {
    return (
        <svg height="48" width="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <title>Handshake</title>
            <g fill={props.fill} stroke={props.fill} strokeLinecap="square" strokeWidth="2">
                <path
                    d="M37.989,31.844a2.749,2.749,0,0,0,3.981-.1h0a2.749,2.749,0,0,0-.067-3.761L31.887,17.71"
                    fill="none"
                    strokeLinecap="butt"
                />
                <path
                    d="M27.994,37.885l1.294,1.294a2.824,2.824,0,0,1,0,3.994h0A2.813,2.813,0,0,1,28,43.91"
                    fill="none"
                />
                <path
                    d="M36.011,29.866l2.757,2.758a2.843,2.843,0,0,1,0,4.022h0a2.843,2.843,0,0,1-4.022,0L31.99,33.889"
                    fill="none"
                />
                <path d="M34.2,36.1a2.824,2.824,0,0,1,0,3.994h0a2.826,2.826,0,0,1-3.994,0" fill="none" />
                <rect
                    height="5.688"
                    width="6.743"
                    fill="none"
                    rx="2.844"
                    ry="2.844"
                    stroke={props.fill}
                    transform="translate(-20.445 17.871) rotate(-45)"
                    x="7.977"
                    y="30.771"
                />
                <rect
                    height="5.648"
                    width="6.187"
                    fill="none"
                    rx="2.824"
                    ry="2.824"
                    stroke={props.fill}
                    transform="translate(-23.128 26.136) rotate(-45)"
                    x="16.892"
                    y="38.161"
                />
                <path
                    d="M9.7,31.243l-.42.42a2.749,2.749,0,0,1-3.981-.1h0A2.75,2.75,0,0,1,5.364,27.8l.42-.43a2.754,2.754,0,0,1,3.87-.066h0A2.753,2.753,0,0,1,9.7,31.243Z"
                    fill="none"
                    stroke={props.fill}
                />
                <path
                    d="M42,22V18.625l3-3.052L34.558,5.131,32.69,7H28a8.868,8.868,0,0,0-6.235,2.56L15.1,16.491a2.464,2.464,0,0,0,3.15,3.754l7.1-4.575a6.45,6.45,0,0,0,9.763-.1"
                    fill="none"
                    stroke={props.fill}
                />
                <polyline fill="none" points="6 22 6 18.625 3 15.573 13.442 5.131 15.31 7 19 7" />
                <rect
                    height="5.648"
                    width="5.947"
                    fill="none"
                    rx="2.824"
                    ry="2.824"
                    stroke={props.fill}
                    transform="translate(-21.824 21.997) rotate(-45)"
                    x="12.667"
                    y="34.518"
                />
            </g>
        </svg>
    );
};

export default Handshake;
